import { getIsUserVerified } from "@worldcoin/minikit-js";
import useSWR from "swr";

export function useIsUserVerified(address: string) {
  const response = useSWR(`verify-${address}`, () => {
    return getIsUserVerified(address)
  }, {
    dedupingInterval: 720_000,
    keepPreviousData: true,

  });
//   console.log(`verify-${address}`,{data:response.data})
  return response;
}
